// extracted by mini-css-extract-plugin
export default {"wrap":"List_wrap__N1Y7h","image":"List_image__YTHRQ","body":"List_body__eBYR3"};